import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { StateService } from "@core-services/state.service";
import { BestModel } from "../entities/best.model";
import { BestVipLevelsThreshold } from "@modules/new_account/features/my-best/domain/entities/best-vip-levels-threshold.model";

const initialState: BestModel | null = null;

@Injectable({
	providedIn: "root"
})
export class BestStateService extends StateService<BestModel> {
	constructor() {
		super(initialState);
	}

	public getState$(): Observable<BestModel> {
		return this.select((state) => state);
	}

	public updateState(bestModel: BestModel): void {
		// Add calculated levels for convenience
		const currentVipLevel = this.getCurrentVipLevel(bestModel);
		const nextVipLevel = this.getNextVipLevel(bestModel);
		const currentTradeLevel = this.getCurrentTradeLevel(bestModel);
		const nextTradeLevel = this.getNextTradeLevel(bestModel);
		const currentWeeklyVipLevel = this.getCurrentWeeklyVipLevel(bestModel);
		const nextWeeklyVipLevel = this.getNextWeeklyVipLevel(bestModel);

		// TODO-BEST: merge VIP levels?

		this.setState({
			...bestModel,
			currentVipLevel,
			nextVipLevel,
			currentTradeLevel,
			nextTradeLevel,
			currentWeeklyVipLevel,
			nextWeeklyVipLevel
		});
	}

	private getNextVipLevel(bestModel: BestModel): BestVipLevelsThreshold {
		return bestModel.all_vip_levels.find((level) => +bestModel.balance < +level.min_amount);
	}

	private getCurrentVipLevel(bestModel: BestModel): BestVipLevelsThreshold {
		const allLevels = bestModel.all_vip_levels.filter((level) => +bestModel.balance >= +level.min_amount);
		return allLevels[allLevels.length - 1];
	}

	private getNextTradeLevel(bestModel: BestModel): BestVipLevelsThreshold {
		return bestModel.all_trade_bonus_levels?.find((level) => +bestModel.trade_volume < +level.min_amount);
	}

	private getCurrentTradeLevel(bestModel: BestModel): BestVipLevelsThreshold {
		if (!bestModel.all_trade_bonus_levels) {
			return null;
		}

		const allLevels = bestModel.all_trade_bonus_levels.filter(
			(level) => +bestModel.trade_volume >= +level.min_amount
		);
		return allLevels[allLevels.length - 1];
	}

	private getNextWeeklyVipLevel(bestModel: BestModel): BestVipLevelsThreshold {
		return bestModel.all_weekly_vip_levels?.find((level) => +bestModel.balance < +level.min_amount);
	}

	private getCurrentWeeklyVipLevel(bestModel: BestModel): BestVipLevelsThreshold {
		if (!bestModel.all_weekly_vip_levels) {
			return null;
		}

		const allLevels = bestModel.all_weekly_vip_levels.filter((level) => +bestModel.balance >= +level.min_amount);
		return allLevels[allLevels.length - 1];
	}
}
